import apiAddress from "./apiAddress";

const api = `${apiAddress}/api`;
export default api;
